<script>
    import AuthService from "../services/auth.service";
    import AlteryxService from "../services/alteryx.service";

    export let user = null;
    let alteryxAllowed = false;
    userAllowed();
    // Verify if user has permission to see this section
    async function userAllowed() {
        try {
            const response = await AlteryxService.isAllowed();
            if (response && response.data.ok) {
                alteryxAllowed = response.data.ok;
                if (ENVIRONMENT.IS_OPERATIONS_KPIS) alteryxAllowed = true;
            }
        } catch (e) {
            console.log(e);
            errorMessage = e.message;
        }
    }
</script>

<nav class="navbar navbar-expand-lg navbar-dark bg-dark bg-riverside">
    <a class="navbar-brand" href="/dashboard">
        <img src="/img/riverside-logo.svg" height="20" class="img-riverside">
        KEY PERFORMANCE INDICATORS
    </a>
    <div class="right-items">
        <a id="landing-page-url" href="{ENVIRONMENT.LANDING_PAGE_URL}" target="_blank"
            ><i class="fa fa-th" aria-hidden="true" /> Riverside Ecosystem</a
        >
        <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon" />
        </button>
        <div class="collapse navbar-collapse" id="navbarMenu">
            <ul class="navbar-nav ml-auto">
                {#if user}
                    <li class="nav-item dropdown">
                        <a
                            class="nav-link dropdown-toggle"
                            href="#"
                            id="navbarDropdown"
                            role="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            {user.name}
                        </a>
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="navbarDropdown"
                        >
                            {#if AuthService.can("SET_HR_PERMISSIONS")}
                                <a class="dropdown-item" href="/permissions"
                                    >Permissions</a
                                >
                            {/if}
                            {#if AuthService.can("RESTORE_SECTION") || AuthService.can("RESTORE_TEAM")}
                                <a class="dropdown-item" href="/trashbin"
                                    >Trash Bin</a
                                >
                            {/if}
                            {#if alteryxAllowed}
                                <a class="dropdown-item" href="/alteryx"
                                    >Alteryx</a
                                >
                            {/if}
                            <a class="dropdown-item" href="/help/index">Help</a>
                            <div class="dropdown-divider" />
                            <a class="dropdown-item" href="/logout">Logout</a>
                        </div>
                    </li>
                {:else}
                    <li class="nav-item">
                        <a class="nav-link" href="/help/index">Help</a>
                    </li>
                {/if}
            </ul>
        </div>
    </div>
</nav>

<style>
    .right-items {
        width: 100%;
        text-align: right;
    }

    #landing-page-url {
        color: #fff;
    }

    #navbarMenu {
        display: inline-block !important;
    }
</style>